/* Size chart dialog (snippets/aura-size-chart.liquid): opens from the "Tabulka velikostí" link, highlights the column of
   the size selected on the page, closes with the cross, Esc, a click outside, or the phone's back button. */
(function () {
  'use strict';

  function setup(dialog) {
    var id = dialog.id;
    var section = dialog.closest('[data-product-section]') || document;
    var sizeOption = dialog.getAttribute('data-size-option-index');
    var sizes = [];
    try { sizes = JSON.parse(dialog.getAttribute('data-sizes') || '[]'); } catch (e) { sizes = []; }
    var root = document.documentElement;
    var pushed = false;
    var fromPop = false;
    var pendingBack = false;   // our own history.back() after a close, its popstate must not touch the dialog
    var openAfterBack = false; // reopened before that popstate arrived: open once it has

    function selectedSize() {
      var group = section.querySelector('.product-option[data-option-index="' + sizeOption + '"]');
      if (!group) return null;
      var button = group.querySelector('[data-option-value].is-selected');
      if (button) return button.getAttribute('data-option-value');
      var select = group.querySelector('select');
      return select ? select.value : null;
    }

    function highlight() {
      var index = sizes.indexOf(selectedSize());
      dialog.querySelectorAll('[data-size-index]').forEach(function (cell) {
        cell.classList.toggle('is-selected', Number(cell.getAttribute('data-size-index')) === index);
      });
      dialog.querySelectorAll('[data-selected-mark]').forEach(function (mark) {
        mark.hidden = Number(mark.getAttribute('data-selected-mark')) !== index;
      });
    }

    function open() {
      if (dialog.open) return;
      if (pendingBack) {
        openAfterBack = true;
        return;
      }
      highlight();
      dialog.showModal();
      root.classList.add('is-size-chart-open');
      try {
        history.pushState(Object.assign({}, history.state, { auraSizeChart: id }), '');
        pushed = true;
      } catch (e) {
        pushed = false;
      }
    }

    dialog.addEventListener('close', function () {
      root.classList.remove('is-size-chart-open');
      if (pushed && !fromPop && history.state && history.state.auraSizeChart === id) {
        pendingBack = true;
        history.back();
      }
      pushed = false;
      fromPop = false;
    });
    window.addEventListener('popstate', function () {
      if (pendingBack) {
        pendingBack = false;
        if (openAfterBack) {
          openAfterBack = false;
          open();
        }
        return;
      }
      if (!dialog.open) return;
      fromPop = true;
      dialog.close();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.querySelectorAll('[data-aura-size-chart-close]').forEach(function (button) {
      button.addEventListener('click', function () { dialog.close(); });
    });
    document.querySelectorAll('[data-aura-size-chart-open="' + id + '"]').forEach(function (trigger) {
      trigger.addEventListener('click', open);
    });
    section.addEventListener('aura:variant-change', highlight);
  }

  function init() {
    document.querySelectorAll('[data-aura-size-chart]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
